import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Button, Col, Form as BootstrapForm, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import * as yup from "yup";
import { StorageService } from "../../../services/storage.service";
import actions from "../../../store/actions/actions";
import expectmelogo from "../icons/expectmelogo.svg";
import Logo from "../SidebarSvg/Logo.svg";
import { AuthHeader } from "./AuthHeader";

const Login = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const [availableLanguagesFromSelector, setAvailableLanguagesFromSelector] = useState(null);
  const languages = useSelector((state) => state?.hotelLanguageSettings?.languages);
  const isLanguages = useSelector((state) => state?.hotelLanguageSettings?.isLanguages);
  const [defaultSelectedLanguage, setDefaultLanguage] = useState(null);
  const [availableFilteredLanguages, setAvailableFilteredLanguages] = useState([]);
  const valueAsKey = false
  const isLoading = useSelector((state) => state.network.isLoading);
  const history = useHistory();
  const localService = new StorageService();

  const formInitialValue = {
    email: "",
    password: "",
  };
  const formSchema = yup.object().shape({
    email: yup.string().email().required("Please Enter email"),
    password: yup.string().required("Please Enter Password"),
  });


  useEffect(() => {
    dispatch(actions.getLanguage());
  }, []);
  // useEffect(() => {
  //   if (isLoading) {
  //     history.push("/home");
  //   }
  // }, [isLoading]);
  useEffect(() => {
    if (languages && languages?.length) {
      setAvailableFilteredLanguages(languages)
    }
  }, [languages]);

  const signUp = (payload) => {
    dispatch(actions.login(payload));
  };

  return (
    <React.Fragment>
      <Formik
        initialValues={{
          ...formInitialValue,
        }}
        validationSchema={formSchema}
        onSubmit={(values) => {
          const payload = {
            ...values
          }
          signUp(payload)

        }}
      >
        {({
          handleChange,
          errors,
          values,
          touched,
          setFieldValue,
          submitForm,
        }) => (
          <Form>
            <Row className="noMargin">
              <Col md={6} sm={12} xs={12} className="loginleft">
                <div className="logo">
                  <img alt="expect-me-logo" src={expectmelogo} />
                </div>
                <AuthHeader availableFilteredLanguages={availableFilteredLanguages} />
                <div className="dashborad-login-form">
                  <div>
                    <span className="welcometext">{t("Modules.Login.Welcome Back")}</span>
                    <br />
                    <span className="welcome-description">
                      {t("Modules.Login.Welcome Back Description")}
                    </span>
                    <br />
                    <br />
                  </div>
                  <BootstrapForm.Group>
                    <BootstrapForm.Label>{t("Modules.Login.Enter Your Email")} <span style={{ color: "red" }}>*</span></BootstrapForm.Label>
                    <BootstrapForm.Control
                      type="email"
                      name="email"
                      onChange={handleChange}
                      isInvalid={touched?.email && errors?.email}
                      value={values?.email}
                    ></BootstrapForm.Control>
                  </BootstrapForm.Group>
                  <BootstrapForm.Group className="mt-3">
                    <BootstrapForm.Label>{t("Modules.Login.Enter Your Password")} <span style={{ color: "red" }}>*</span></BootstrapForm.Label>
                    <BootstrapForm.Control
                      type="password"
                      name="password"
                      onChange={handleChange}
                      isInvalid={touched?.password && errors?.password}
                      value={values?.password}
                      onChange={handleChange}
                    ></BootstrapForm.Control>
                  </BootstrapForm.Group>
                  <BootstrapForm.Check
                    className="mt-3"
                    inline
                    label={t("Modules.Login.Remember me")}
                    name="remember_me"
                    type="checkbox"
                  />
                  <Row className="mt-3">
                    <Col md={6} sm={6} xl={6}>
                      <Button variant="primary" type="submit">
                        {t("Modules.Login.Login")}
                      </Button>
                    </Col>
                    <Col md={6} sm={6} xl={6}>
                      <Link to="/forget-password">
                        <Button variant="secondary">{t("Modules.Login.Forgot password")}</Button>
                      </Link>
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col md={6} sm={12} xs={12} className="loginright">
                <div className="login-right-panel ">
                  <div className="background-login" />
                  <div className="dashboard-header-login">
                    <img alt="logo" src={Logo} />
                  </div>
                </div>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </React.Fragment>
  );
};

export default Login;
